$(document).ready(function () {


    $(document).on('click', '#search_customer', function (event) {
        event.preventDefault();

        let item = $("#item").val();
        let value = $("#value").val();
        loading_small('div_result');

        if ($.trim(item) === "") {
            Swal.fire('Advertencia', 'Seleccione un criterio de búsqueda', 'error');
            $("#div_result").html("");
        } else if ($.trim(value) === "") {
            Swal.fire('Advertencia', 'Ingrese un valor a buscar', 'error');
            $("#div_result").html("");
        } else {

            $.ajax({
                url: window.location.origin + '/find-wallet-by-options',
                type: 'POST',
                data: {
                    item: item,
                    value: value
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    $("#div_result").html(response);

                    const dataTable = $('#table_resutl_custumer').dataTable({
                        "language": {
                            "url": window.location.origin + "/json/Spanish.json"
                        },
                    });

                    dataTable.on('draw.dt', function () {
                        $('[data-toggle="tooltip"]').tooltip({
                            trigger: 'hover'
                        });
                    });


                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }

    });

    $(document).on('click', '.modal_enter_initial_balance', function (e) {
        e.preventDefault();

        let card_num = $(this).data('card_num');
        let id = $(this).data('id');

        $.ajax({
            url: window.location.origin + '/get-data-wallet-initial',
            type: 'POST',
            data: {
                card_num: card_num,
                id: id
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                $(".item-id").val(id);
                $(".item-num_card").val(card_num);
                $('#balance').attr('readonly', false);
                Swal.fire({
                    title: 'Confirmación',
                    text: response['msg'],
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $(".item-balance").val(response.transaction ? response.transaction.amount ?? 0 : 0);
                        $(".item-dependencia").val(response.wallet.dependencies_id)
                        $("#modal_enter_initial_balance").modal('show');
                        if (response.success == 'true') {
                            $('#balance').attr('readonly', true);
                        }
                    }
                });
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    })

    $(document).on('submit', '#form-initial-balance', function (e) {
        e.preventDefault();
        let saldo = $(".item-balance").val();
        let dependencie = $(".item-dependencia option:selected").val();

        let num_card = $(".item-num_card").val();
        let id = $(".item-id").val();

        $.ajax({
            url: window.location.origin + '/save-initial-balance',
            type: 'POST',
            data: {
                id: id,
                dependencie: dependencie,
                balance: saldo,
                num_card: num_card
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                $("#modal_enter_initial_balance").modal('hide');
                Swal.fire('Aviso', response['msg'], 'success');
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    })

    $(document).on('click', '.modal_detail_wallet', function (e) {
        $(".item-name").html($(this).data('name'));
        $(".item-monedero").html($(this).data('card_num'));
        $(".item-email").html($(this).data('email'));
        $(".item-phone").html($(this).data('phone'));
        $(".item-saldo").html($(this).data('saldo'));
        $("#modal_detail_wallet_").modal('show');
    })

    $(document).on('click', '.account_status', function (e) {
        e.preventDefault();
        $('#account_status_modal').modal('show');
        let data = new FormData()
        data.append('num_card',$(this).data('num_card'))
        let customer_name = $(this).data('customer_name')
        sendData(data,'get-transactions-by-customer',customer_name)
    })

    function sendData(data, route, customer_name) {
        togglePreloader();
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                togglePreloader();
                $(".title_customer_name").val(customer_name)
                document.getElementById('div_result_transactions').innerHTML = response;
            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $("#error-" + index).text(value);
                });
            }
        })
    }



});
